import { QUERY_GET_FACTORY_CITIES, QUERY_GET_FACTORY_TERMINATION_CITIES } from '../../fetch/constantQueries'
import { baseThunk } from '../../fetch/basicThunk';

export const getFactoryCities = baseThunk(`factoryCities/getCities`, QUERY_GET_FACTORY_CITIES, "GET")
export const getFactoryTerminationCities = baseThunk(`factoryCities/getTerminationCities`, QUERY_GET_FACTORY_TERMINATION_CITIES, "GET")
